var uncurryThis = require('../internals/function-uncurry-this');

module.exports = uncurryThis([].slice);



//////////////////
// WEBPACK FOOTER
// ./~/core-js/internals/array-slice.js
// module id = 111
// module chunks = 0